import { createContext } from "react";

/**
 * Which screen `useMaterialViewer` opens a file in. Unset, it is `MaterialViewerModal`;
 * the student's laptop shell provides its own, with the same props:
 * `{ show, material, url, pdfUrl, onClose, onDownload }`. Whatever the screen, the file
 * is drawn by `ContentViewer` and its download rule is `canDownloadFile`.
 */
const MaterialViewerContext = createContext(null);

export default MaterialViewerContext;
